<template>
  <!-- <div
    class="box messRemindToFill"
    v-html="messRemindToFill">
  </div> -->
  <div>
    <transition name="fade">
      <div v-if="showLateWithSchedule" class="notify-alert-box messLateWithSchedule" @click="emitGoToPersonal()">
        <span class="message">
          <h5>{{ $t('scheduleYourWorkHours') }}</h5>
          <p>
            {{ $t('youAreLate') }} {{ $t('submitYourSchedule') }}
            <span>{{ $t('everyDayByHour', { day: overdueStatus.submitDeadlineDay, hour: overdueStatus.submitDeadlineTime }) }}</span>
          </p>
        </span>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showTeamMembersSchedule" class="late-teammembers-alert-wrapper">
        <div
          class="notify-alert-box messTeamMembersSchedule"
          :class="{
            'list-shown': $store.state.showListOfLateTeamMembers,
            'list-hidden': !$store.state.showListOfLateTeamMembers,
          }"
          @click="toggleListOfLateTeamMembers()"
        >
          <span class="message">
            <h5>{{ $tc('lateTeamMembers', overdueStatus.teamNotFilled.length) }}</h5>
          </span>
        </div>
        <transition name="slide">
          <div v-if="$store.state.showListOfLateTeamMembers" class="late-teammembers-list">
            <div v-for="(member, index) in overdueStatus.teamNotFilled" :key="member.id" class="member-wrapper" @click="emitGoToPersonal(member.id)">
              <img
                :src="getAvatar(member)"
                :style="{
                  'background-color': member.color || colorsHashArray(index).value,
                }"
              />
              <p>{{ member.name }}</p>
            </div>
          </div>
        </transition>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showRemindToFill" class="notify-alert-box messRemindToFill" @click="emitGoToPersonal()">
        <span class="message">
          <h5>{{ $t('scheduleYourWorkHoursForTheComingWeek') }}</h5>
        </span>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showChangedDeadline" class="notify-alert-box messChangedDeadline">
        <span class="message">
          <h5>{{ $t('deadlineChange') }}</h5>
          <p>
            {{ $t('scheduleYourWorkHoursForTheComingWeek') }}
            <span>
              {{ $t('everyDayByHour', { day: overdueStatus.deadlineChangedToDay, hour: overdueStatus.deadlineChangedToHour }) }}
            </span>
          </p>
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
import Constants from '@/components/Constants'
import User from '@/components/User'
import EventBus from '@/EventBus'

export default {
  name: 'CalendarBellPopupAlert',

  mixins: [User, Constants],

  props: {
    overdueStatus: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {}
  },

  computed: {
    showLateWithSchedule() {
      return (
        Object.keys(this.overdueStatus).length > 0 &&
        this.overdueStatus.userTeamWeekStatus === 'late' &&
        this.overdueStatus.submitDeadlineDay &&
        this.overdueStatus.submitDeadlineTime
      )
    },
    showRemindToFill() {
      return Object.keys(this.overdueStatus).length > 0 && this.overdueStatus.userTeamWeekStatus === 'remind'
    },
    showChangedDeadline() {
      return Object.keys(this.overdueStatus).length > 0 && this.overdueStatus.deadlineChangedToDay && this.overdueStatus.deadlineChangedToHour
    },
    showTeamMembersSchedule() {
      return this.overdueStatus.teamNotFilled && this.overdueStatus.teamNotFilled.length > 0
    },
  },

  methods: {
    toggleListOfLateTeamMembers() {
      this.$store.commit('setShowListOfLateTeamMembers', !this.$store.state.showListOfLateTeamMembers)
    },
    emitGoToPersonal(userId = this.userId) {
      EventBus.$emit('go-to-personal', { person: userId, date: this.overdueStatus.weekDate })
    },
  },
}
</script>
<style lang="scss">
.notify-alert-box {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: $bold;
    font-size: 16px;
    color: $white;
    letter-spacing: 0;
    margin: 0 0 0px 0;
  }
  p {
    margin-top: 6px;
    span {
      font-family: $bold;
    }
  }
}
</style>

<style scoped lang="scss">
.notify-alert-box {
  display: flex;
  line-height: 20px;
  margin-bottom: 20px;
  padding: 54px 36px 12px 12px;
  font-family: $regular;
  letter-spacing: 0;
  font-size: 14px;
  color: $white;
  letter-spacing: 0;
  line-height: 20px;
  background: $blue url(~@/assets/_desktop/_notifications/bell-ringing.svg) 12px 12px no-repeat;
  transition: background-color 0.1s ease-in;
  position: relative;

  .message {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 0px;
    }
  }

  &.messRemindToFill::after,
  &.messLateWithSchedule::after {
    display: block;
    width: 12px;
    height: 12px;
    content: url(~@/assets/_desktop/_notifications/disclose-arrow.svg);
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-100%);
  }
}

.late-teammembers-alert-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;
}

.late-teammembers-list {
  display: flex;
  flex-direction: column;
  background-color: #ffe0e6; // equals rgba($red, 0.2) but this way it's not transparent
  padding: 8px 0px;
  z-index: 0;
  .member-wrapper {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    width: 100%;
    cursor: pointer;
    transition: background-color 0.15s ease-in-out;
    &:hover {
      background-color: #ffebee;
    }
    img {
      height: 24px;
      width: 24px;
      border-radius: 24px;
      margin-right: 12px;
    }
    p {
      font-family: $bold;
      word-break: break-all;
    }
  }
}

.messRemindToFill {
  background-color: $blue;
  cursor: pointer;
  &:hover {
    background-color: rgba($blue, 0.8);
  }
}

.messLateWithSchedule {
  background-color: $red;
  cursor: pointer;
  &:hover {
    background-color: rgba($red, 0.8);
  }
}

.messChangedDeadline {
  background-color: $blue;
  background-image: url(~@/assets/_desktop/_notifications/deadline.svg);
}

.messTeamMembersSchedule {
  background-color: $red;
  cursor: pointer;
  z-index: 1;
  margin-bottom: 0px;
  background-image: url(~@/assets/_desktop/_notifications/warning.svg);
  &:hover {
    background-color: #ff7d97; // equals rgba($red, 0.8) but this way it's not transparent
  }
  &.list-hidden {
    &:after {
      display: block;
      width: 12px;
      height: 12px;
      content: url(~@/assets/_desktop/_notifications/disclose-arrow-down.svg);
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-100%);
    }
  }
  &.list-shown {
    position: sticky;
    top: 72px;
    &:after {
      display: block;
      width: 12px;
      height: 12px;
      content: url(~@/assets/_desktop/_notifications/disclose-arrow-up.svg);
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-100%);
    }
  }
}
</style>
